import { render, staticRenderFns } from "./redirectTo.vue?vue&type=template&id=5f234596&scoped=true"
import script from "./redirectTo.vue?vue&type=script&lang=js"
export * from "./redirectTo.vue?vue&type=script&lang=js"
import style0 from "./redirectTo.vue?vue&type=style&index=0&id=5f234596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f234596",
  null
  
)

export default component.exports